import React from 'react';
import PropTypes from 'prop-types';
import { Button, Drawer } from '@duxton-web/ui';

import useCheckMobileScreen from 'hooks/useCheckMobileScreen';

import styles from './modal-drawer.less';

const ModalDrawer = ({
  open,
  title,
  buttonText,
  content,
  disableButton,
  onClose,
  onSubmit,
}) => {
  const isMobile = useCheckMobileScreen();

  return (
    <Drawer
      open={open}
      height={'auto'}
      placement={isMobile ? 'bottom' : 'right'}
      className={styles.mobileDrawerContent}
      title={title}
      styles={{
        footer: {
          borderTop: 0,
        },
      }}
      footer={
        buttonText && (
          <Button
            block
            size="large"
            type="primary"
            className={styles.actionButton}
            onClick={onSubmit}
            disabled={disableButton}
          >
            {buttonText}
          </Button>
        )
      }
      onClose={onClose}
    >
      {content}
    </Drawer>
  );
};

ModalDrawer.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  buttonText: PropTypes.string,
  content: PropTypes.node,
  disableButton: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
};

ModalDrawer.defaultProps = {
  open: false,
  title: '',
  buttonText: '',
  content: null,
  disableButton: false,
  onClose: () => {},
  onSubmit: () => {},
};

export default ModalDrawer;
